import { useContext } from 'react';
import type { Version } from '../contexts/VersionsContext';
import { VersionsContext } from '../contexts/VersionsContext';

export const useVersionList = (): Version[] => {
  const { versions } = useContext(VersionsContext);

  return versions;
};
